<template>
  <div class="app ma-4">
    <div class="text-h4">Relatórios de Fila</div>
    <v-tabs v-model="tabs" background-color="background" class="fixed-tabs-bar">
      <v-tab v-for="n in tipos" :key="n">
        {{ tipo[n - 1] }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs" class="app">
      <v-tab-item>
        <RelatorioResumido />
      </v-tab-item>
      <v-tab-item>
        <RelatorioDetalhado />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import RelatorioResumido from '../_components/resumidoFila/_views/RelatorioSinteticoHome'
import RelatorioDetalhado from '../_components/detalhadoFila/_views/RelatorioFilaDetalhado'

export default {
  name: 'RelatorioFilas',
  components: { RelatorioResumido, RelatorioDetalhado },
  data: () => ({
    tabs: 2,
    tipos: 2,
    tipo: ['Resumido', 'Detalhado'],
  }),
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}

.fixed-tabs-bar {
  position: -webkit-sticky;
  position: sticky;
  top: 48px;
  z-index: 15;
}
</style>
